import React from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentScreen, clearCart, setLoyaltyCode, setOrderMetadata } from '../../store/orderSlice';
import StartOverButton from '../ui/StartOverButton';
import PanarottisIcon from '../../data/PanaImages/PanarottisIcon.png';
import CardPaymentImage from '../../data/PanaImages/CardPayment.png';

const PaymentScreen: React.FC = () => {
  const dispatch = useDispatch();

  const nexaRustStack = '"Nexa Rust Sans Black A", "Museo Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

  const generateOrderNumber = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 5; i += 1) {
      const index = Math.floor(Math.random() * chars.length);
      result += chars[index];
    }
    return result;
  };

  const createOrderMetadata = () => {
    const orderNumber = generateOrderNumber();
    const timestamp = new Date().toISOString();
    dispatch(setOrderMetadata({ orderNumber, timestamp }));
  };

  const handleBackToCart = () => {
    dispatch(setCurrentScreen('cart'));
  };
  const handlePayHere = () => {
    createOrderMetadata();
    dispatch(setCurrentScreen('pay-here'));
  };

  const handlePayAtCounter = () => {
    createOrderMetadata();
    dispatch(setCurrentScreen('pay-at-counter'));
  };

  const handleStartOver = () => {
    dispatch(clearCart());
    dispatch(setLoyaltyCode(null));
    dispatch(setCurrentScreen('welcome'));
  };

  return (
    <div className="min-h-screen bg-[#f2f1ec] flex flex-col items-center px-10 pt-12">
      <div className="flex flex-col items-center w-full flex-1">
        <img
          src={PanarottisIcon}
          alt="Panarottis"
          className="w-[100px] h-[75.76px] object-contain"
        />
        <h1
          className="mt-10 text-center uppercase text-[#185C53]"
          style={{
            fontFamily: nexaRustStack,
            fontSize: '80px',
            lineHeight: '88px',
            fontWeight: 900,
            letterSpacing: '2px',
          }}
        >
          Where Would You Like to Pay?
        </h1>

        <div className="mt-12 w-full max-w-[520px]">
          <div className="flex flex-col items-center border border-[#d5d1c9] rounded-[32px] px-10 py-16 shadow-sm">
            <img
              src={CardPaymentImage}
              alt="Pay with card"
              className="w-[360px] h-[398.71px] object-contain"
            />
            <button
              type="button"
              onClick={handlePayHere}
              className="mt-10 px-16 py-4 rounded-tr-[18px] rounded-bl-[18px] rounded-tl-none rounded-br-none uppercase shadow-[0_12px_24px_rgba(0,0,0,0.1)]"
              style={{
                fontFamily: nexaRustStack,
                fontSize: '40px',
                lineHeight: '44px',
                fontWeight: 900,
                backgroundColor: '#E32B26',
                color: '#f2f1ec',
              }}
            >
              Pay Here
            </button>
          </div>
              </div>

        <div
          className="mt-8 text-center uppercase"
          style={{
            fontFamily: nexaRustStack,
            fontSize: '60px',
            lineHeight: '64px',
            fontWeight: 900,
            color: '#3C3C3B',
          }}
        >
          OR
              </div>

        <button
          type="button"
          onClick={handlePayAtCounter}
          className="mt-6 px-20 py-5 rounded-tr-[18px] rounded-bl-[18px] rounded-tl-none rounded-br-none uppercase shadow-[0_12px_24px_rgba(0,0,0,0.1)]"
          style={{
            fontFamily: nexaRustStack,
            fontSize: '40px',
            lineHeight: '44px',
            fontWeight: 900,
            backgroundColor: '#00A294',
            color: '#f2f1ec',
          }}
        >
          Pay at Counter
        </button>
              </div>

      <div className="w-full flex flex-col items-center gap-4 mt-auto pb-0">
        <button
          type="button"
          onClick={handleBackToCart}
          className="px-12 py-3 rounded-[18px] uppercase"
          style={{
            fontFamily: nexaRustStack,
            fontSize: '30px',
            lineHeight: '34px',
            fontWeight: 900,
            backgroundColor: 'transparent',
            color: '#00A294',
            border: '2px solid #00A294',
          }}
        >
          Back to Order
        </button>

        <StartOverButton onClick={handleStartOver} />
      </div>
    </div>
  );
};

export default PaymentScreen; 